import { render, staticRenderFns } from "./EmptyRouteIcon.vue?vue&type=template&id=367d2a2a"
import script from "./EmptyRouteIcon.vue?vue&type=script&lang=js"
export * from "./EmptyRouteIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports